import { defineMessages } from 'react-intl'

export default defineMessages({
  secretaryAccount: {
    id: 'settings.secretary.secretaryAccount',
    defaultMessage: 'Secretary Account'
  },
  createSecretaryAccount: {
    id: 'settings.secretary.createSecretaryAccount',
    defaultMessage: 'Create Secretary Account'
  },
  removeSecretary: {
    id: 'settings.secretary.removeSecretary',
    defaultMessage: 'Remove Secretary'
  },
  areYouSure: {
    id: 'settings.secretary.areYouSure',
    defaultMessage: 'Are you sure?'
  },
  actionCannotBeUndone: {
    id: 'settings.secretary.actionCannotBeUndone',
    defaultMessage: 'This action cannot be undone'
  },
  cancel: {
    id: 'settings.secretary.cancel',
    defaultMessage: 'Cancel'
  },
  remove: {
    id: 'settings.secretary.remove',
    defaultMessage: 'Remove'
  },
  name: {
    id: 'settings.secretary.name',
    defaultMessage: 'Name'
  },
  email: {
    id: 'settings.secretary.email',
    defaultMessage: 'Email'
  },
  password: {
    id: 'settings.secretary.password',
    defaultMessage: 'Password'
  },
  secretaryCreatedSuccess: {
    id: 'settings.secretary.secretaryCreatedSuccess',
    defaultMessage: 'Secretary created successfully'
  },
  emailCannotBeReused: {
    id: 'settings.secretary.emailCannotBeReused',
    defaultMessage: 'Secretary account removed'
  },
  emailAlreadyInUse: {
    id: 'settings.secretary.emailAlreadyInUse',
    defaultMessage: 'Email already in use'
  },
  passwordTooShort: {
    id: 'settings.secretary.passwordTooShort',
    defaultMessage: 'Password must be at least 8 characters'
  },
  anErrorOccurred: {
    id: 'settings.secretary.anErrorOccurred',
    defaultMessage: 'An error occurred. Please try again.'
  },
  failedToRemove: {
    id: 'settings.secretary.failedToRemove',
    defaultMessage: 'Failed to remove secretary. Please try again.'
  },
  sectionHeading: {
    id: 'settings.secretary.sectionHeading',
    defaultMessage: 'Secretary'
  },
  namePlaceholder: {
    id: 'settings.secretary.namePlaceholder',
    defaultMessage: "Secretary's full name"
  },
  emailPlaceholder: {
    id: 'settings.secretary.emailPlaceholder',
    defaultMessage: 'secretary@example.com'
  },
  passwordPlaceholder: {
    id: 'settings.secretary.passwordPlaceholder',
    defaultMessage: 'Minimum 8 characters'
  },
  creatingText: {
    id: 'settings.secretary.creatingText',
    defaultMessage: 'Creating...'
  },
  inviteSecretary: {
    id: 'settings.secretary.inviteSecretary',
    defaultMessage: 'Invite a secretary'
  },
  sendInvitation: {
    id: 'settings.secretary.sendInvitation',
    defaultMessage: 'Send invitation'
  },
  invitationSent: {
    id: 'settings.secretary.invitationSent',
    defaultMessage: 'Secretary invitation sent'
  },
  seatLimitReached: {
    id: 'settings.secretary.seatLimitReached',
    defaultMessage: 'This clinic has reached its five-secretary limit'
  }
})
